import {
  HonestPricingLawServiceFeeTypes,
  HONEST_PRICING_LAW_SERVICE_FEE_NAMES
} from 'base-ordering/constants/HonestPricingLaw';
import { getHonestLawCustomFeeText } from 'base-ordering/utils/getHonestLawCustomFeeText';
import { getHonestLawServiceFeeText } from 'base-ordering/utils/getHonestLawServiceFeeText';

/**
 *
 * @param {str} displayServiceFee
 *
 * Used to help render the Honest Pricing Law fees for Catering
 * @returns {{
 * feeType: str,
 * bannerFeeText: str,
 * cartItemizedHelperText: str
 * }}
 */
export const mapCartToServiceFeeType = (
  displayServiceFee,
  chargeCustomFee = false,
  chargeServiceFee = false,
  customFeeName = '',
  customFeeAmount = '',
  customFeeFlatOrPercent = ''
) => {
  const feeType = HonestPricingLawServiceFeeTypes.CATERING_ORDER;

  const bannerText = getHonestLawServiceFeeText(
    chargeServiceFee,
    displayServiceFee,
    feeType
  );

  const bannerFeeText = getHonestLawCustomFeeText(
    bannerText,
    chargeCustomFee,
    chargeServiceFee,
    feeType,
    customFeeName,
    customFeeAmount,
    customFeeFlatOrPercent
  );

  const cartItemizedHelperText = `The ${displayServiceFee} ${HONEST_PRICING_LAW_SERVICE_FEE_NAMES[feeType]} helps to cover the cost associated with access to the technology used to place this order online.`;

  return {
    feeType: HONEST_PRICING_LAW_SERVICE_FEE_NAMES[feeType],
    bannerFeeText,
    cartItemizedHelperText
  };
};
